import urlParse from 'url-parse';

export default class URL {
  static getSearch() {
    const parseObject = urlParse(location, true);
    return parseObject.query;
  }
}



// WEBPACK FOOTER //
// ./src/components/url.js